import { truncate } from "lodash";
import React, { ComponentProps, FC } from "react";
import { StyledInputContainer, StyledInput, StyledSpan, StyledLabel } from "../stitches/input";

type StitchesInputProps = ComponentProps<typeof StyledInput>;

export interface InputProps extends StitchesInputProps {
  inputType?: string;
  unit?: string;
  min?: number;
  max?: number;
  step?: number;
  inputTypeFileLabel?: string;
}

// TODO : Add a custom input for submit etc. Only valid for type='text' for now
export const Input: FC<InputProps> = ({
  inputType = "text",
  name,
  unit = "",
  inputTypeFileLabel = "Browse...",
  min,
  max,
  step,
  ...props
}) => (
  <StyledInputContainer>
    {inputType === "file" && <StyledLabel htmlFor={name}>{inputTypeFileLabel}</StyledLabel>}
    <StyledInput
      css={
        !unit || unit.length > 3
          ? {
              paddingRight: "0.5rem",
            }
          : {}
      }
      min={min}
      max={max}
      step={step}
      {...props}
      id={name}
      type={inputType}
    />
    {unit && (
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          right: 0,
          paddingRight: "0.75rem",
          display: "flex",
          alignItems: "center",
        }}
      >
        <StyledSpan>{unit.length > 3 ? truncate(unit, { length: 3, omission: "" }) : unit}</StyledSpan>
      </div>
    )}
  </StyledInputContainer>
);
